// "Capability" grid on the practice view. Six cells, hairline separated.

const CAPABILITIES = [
	{
		heading: "Agentic systems",
		description:
			"Planning and tool-using agents, multi-agent coordination, evaluation harnesses and red teaming, guardrail and policy enforcement layers.",
		tech: "LangGraph · CrewAI · Strands · AutoGen · Semantic Kernel · MCP · A2A · Bedrock AgentCore",
	},
	{
		heading: "Generative AI in production",
		description:
			"RAG and agentic-RAG pipelines, prompt architecture, model hosting and routing, retrieval quality, cost and latency trade-offs.",
		tech: "Bedrock · SageMaker · Vertex AI · vLLM · LiteLLM · Pinecone · OpenSearch · Weaviate · Chroma · FAISS",
	},
	{
		heading: "Document intelligence",
		description:
			"OCR, layout analysis, classification, table and key-value extraction, skew robustness, human-in-the-loop review, machine-readable output.",
		tech: "Textract · PaddleOCR · Azure Document Intelligence · GCP Document AI · Rhubarb",
	},
	{
		heading: "Trust, safety and privacy",
		description:
			"Guardrailing techniques, moderation chains, context-aware grounding for fidelity, PHI de-identification, governance for enterprise deployment.",
		tech: "OWASP LLM Top 10 · Comprehend · LangChain moderation · Comprehend Medical",
	},
	{
		heading: "Computer vision and NLP",
		description:
			"Image models for health signal detection, forgery detection with graph convolutional networks, hybrid supervised and unsupervised language task modelling.",
		tech: "PyTorch · HuggingFace Transformers · Rekognition · Whisper",
	},
	{
		heading: "Enterprise architecture",
		description:
			"Domain and platform architecture, cloud migration and disaster recovery design, MLOps and LLMOps, and the executive alignment that lets any of it ship.",
		tech: "TOGAF L1–L2 · SageMaker Pipelines · Apache MWAA · MLflow · Docker · CDK",
	},
];

export { CAPABILITIES };
